import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query LetterAttachmentsQuery($companyId: ID!, $letterId: ID!) {
    Me {
      Company(id: $companyId) {
        businessPost {
          letter(id: $letterId) {
            preview
            pageCount
            data: attachments {
              id
              tableId
              name
              extension
              filename
            }
          }
        }
      }
    }
  }
`
